// src/components/admin/UnAuth/partner.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { CommonImages } from "../../../../reusableUI/images";
import { logoutAuthentication } from "../../../../Service/apiURL";

const featuresPartners = [
  {
    icon: "/assests/sheald.png",
    title: "For hospitals, agencies & healthcare entities",
  },
  {
    icon: "/assests/sheald.png",
    title: "Minimal investment required",
  },
  {
    icon: "/assests/sheald.png",
    title: "Earn up to 50% commission",
  },
  {
    icon: "/assests/sheald.png",
    title: "Annualized ROI projected at over 40%",
  },
];

const featuresPatients = [
  {
    icon: "/assests/sheald.png",
    title: "Verified, trusted professionals",
  },
  {
    icon: "/assests/sheald.png",
    title: "Transparent, upfront pricing",
  },
  {
    icon: "/assests/sheald.png",
    title: "Flexible booking by days, weeks, or months",
  },
  {
    icon: "/assests/sheald.png",
    title: "Detailed service reports and remote care monitoring",
  },
];

const featuresNurses = [
  {
    icon: "/assests/sheald.png",
    title: "Direct access to clients",
  },
  // {
  //   icon: "/assests/sheald.png",
  //   title: "A professional profile to showcase skills",
  // },
  {
    icon: "/assests/sheald.png",
    title: "Fair pay and weekly payouts",
  },
  {
    icon: "/assests/sheald.png",
    title: "Flexible work schedules",
  },
  {
    icon: "/assests/sheald.png",
    title: "SOS emergency feature",
  },
];

const entities = ["Hospitals", "Companies", "Agencies"];

const benefits = [
  {
    img: "/assests/roi.png",
    alt: "Minimal Investment Required",
    title: "Minimal Investment",
    description: "Get started without heavy capital",
  },
  {
    img: "/assests/comission.png",
    alt: "Earn Generous Commissions",
    title: "Earn Generous Commissions",
    description: "Up to 50% commission on every successful transaction.",
  },
  {
    img: "/assests/returns.png",
    alt: "Strong Returns",
    title: "Strong Returns",
    description: "Annual ROI projected above 40%",
  },
];

const Partner = () => {
  const navigate = useNavigate();

  const handleJoinClick = async (event) => {
    event.preventDefault();
    await logoutAuthentication({ redirect: false });
    navigate("/roleSelection");
  };

  return (
    <div className="min-h-screen p-4 md:p-6 lg:p-6 xl:p-6 fhd:p-0">
      {/* Hero Section */}
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Left Section */}
            <div className="flex flex-col justify-between gap-2 items-center md:items-start mt-24">
              <div>
                <img
                  src="/assests/ceviliyar_mainLogo.png"
                  alt="Ceviliyar Logo"
                  className="w-full max-w-[250px] md:max-w-[300px] lg:max-w-[250px] h-auto mb-6 mx-auto lg:mx-0"
                />

                <p className="mt-1 text-lg md:text-xl text-gray-600 text-center md:text-left font-rubik">
                  Ceviliyar is a digital homecare platform that directly
                  connects patients with licensed, verified nurses and
                  physiotherapists bringing transparency, trust, and convenience
                  to home health services.
                </p>
              </div>
              <div>
                <h1 className="mt-10 text-2xl md:text-4xl font-bold font-prata text-center md:text-left">
                  Partner with us
                </h1>
                <h1 className="mt-4 text-2xl md:text-4xl font-prata font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#008BF8] to-[#2B33C3] text-center md:text-left">
                  Be a Part of India’s Home Health Revolution
                </h1>
              </div>
            </div>

            {/* Right Section */}
            <div className="flex justify-center md:justify-end">
              <img
                src="/assests/header.png"
                alt="Healthcare Header"
                className="w-full max-w-lg h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-0">
        {/* Problem Statement */}
        <div className="bg-[#EDF3FF99]">
          <section className="max-w-7xl mx-auto py-12 px-4">
            <h2 className="text-2xl md:text-3xl font-medium text-blue-800 mb-6 font-prata">
              Why Ceviliyar?
            </h2>
            <p className="text-gray-700 text-lg py-4 font-rubik">
              India is home to over{" "}
              <span className="font-semibold text-blue-700">
                140 million elderly people
              </span>
              , and the demand for dependable home healthcare is growing
              rapidly. Families increasingly prefer home-based care over
              hospitals, but finding trustworthy and skilled nurses or
              physiotherapists remains a serious challenge.
            </p>
            <p className="mt-4 text-gray-700 text-lg font-rubik">
              Many families end up relying on unverified agencies with unclear
              pricing, inconsistent service quality, and no way to monitor the
              care being provided—especially when they're not around.
            </p>
            <p className="mt-4 text-gray-700 text-lg font-rubik">
              At the same time, qualified nurses and physiotherapists often
              struggle to find clients. Many are underpaid by middlemen and lack
              a platform to showcase their skills or work independently.
            </p>
          </section>
        </div>

        <section className="max-w-7xl mx-auto py-8 px-4">
          <h2 className="text-2xl md:text-3xl font-medium text-blue-800 mb-6 font-prata">
            The Ceviliyar Advantage
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {/* For Families/Patients */}
            <div className="bg-white rounded-xl shadow-lg p-0 pb-6">
              <img
                src="/assests/family.png"
                alt="Patient Card Header"
                className="w-full h-42 object-cover rounded-t-xl"
              />
              <h3 className="text-xl font-semibold text-blue-700 mb-3 font-prata text-center mt-4">
                For Families & Patients
              </h3>
              <ul className="space-y-3 list-disc pl-8 mt-5">
                {featuresPatients.map((f) => (
                  <li key={f.title} className="text-gray-800 font-rubik">
                    {f.title}
                  </li>
                ))}
              </ul>
            </div>
            {/* For Nurses/Therapists */}
            <div className="bg-white rounded-xl shadow-lg p-0 pb-6">
              <img
                src="/assests/nurseScreen.png"
                alt="Nurse Card Header"
                className="object-cover rounded-t-xl"
              />
              <h3 className="text-xl font-semibold text-blue-700 mb-3 text-center font-prata mt-4">
                For Nurses & Physiotherapists
              </h3>
              <ul className="space-y-3 list-disc pl-8 mt-5">
                {featuresNurses.map((f) => (
                  <li key={f.title} className="text-gray-800 font-rubik">
                    {f.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto  px-4">
          <h1 className="mt-4 text-2xl md:text-3xl font-medium font-prata text-blue-700 text-center md:text-left pb-10">
            Partner With Us
          </h1>
          <div className="bg-gradient-to-r from-[#1818C3] to-[#1AC5CF] rounded-xl p-6 flex flex-col md:flex-row items-center justify-between">
            <div className="text-white font-rubik">
              <h3 className="text-xl font-medium mb-2">
                India's home healthcare market is projected to reach
              </h3>
              <span className="text-3xl font-bold">₹50,000 crore by 2027</span>
              <p className="mt-2">
                and Ceviliyar is leading the way with a tech-powered,
                human-first approach.
              </p>
            </div>
            <img
              src="/assests/chart.png"
              alt="Growth Chart"
              className="w-32 h-32 mt-4 md:mt-0 md:ml-8"
            />
          </div>
          <div className="py-8 mt-2 md:mt-4">
            <h2 className="text-xl sm:text-2xl md:text-3xl  font-medium font-prata text-left mb-6 md:mb-10">
              Who Can Join?
            </h2>

            <div className="w-full flex flex-col lg:flex-row xl:flex-row justify-between items-center lg:items-center gap-6 sm:gap-10 md:gap-16 lg:gap-20 xl:gap-24 fhd:gap-28">
              {/* Image Section */}
              <div className="w-full lg:w-1/2 flex justify-center md:justify-center lg:justify-start xl:justify-start fhd:justify-start ">
                <img
                  src={CommonImages.partnerBg}
                  alt="Partner"
                  className="w-[260px] sm:w-[250px] md:w-[350px] lg:w-[400px] xl:w-[500px] fhd:w-[500px] h-auto object-contain"
                />
              </div>

              {/* Benefits Section */}
              <ul className="w-full lg:w-1/2 space-y-10">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-center gap-8 md:gap-8">
                    <img
                      src={benefit.img}
                      alt={benefit.alt}
                      className="w-8 h-8 sm:w-10 sm:h-10 md:w-18 md:h-18 xl:w-20 xl:h-20 object-contain"
                    />
                    <div className="flex flex-col">
                      <span className="text-sm sm:text-base md:text-lg xl:text-lg font-semibold text-gray-800 font-rubik">
                        {benefit.title}
                      </span>
                      <span className="text-xs sm:text-sm md:text-sm text-gray-500 font-poppins">
                        {benefit.description}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto  px-4"></section>

        {/* Call to Action */}
        <section className="mb-10 pb-20">
          {/* <p className="mt-1 text-md md:text-lg font-semibold text-gray-600 text-center md:text-center">To join the Ceviliyar, click the join below and get started</p> */}
          <div className="flex justify-center mt-16">
            <Link
              to="/roleSelection"
              onClick={handleJoinClick}
              className="mt-6 bg-custom-gradient hover:bg-blue-700 text-white font-bold py-2.5 px-10 font-rubik rounded-full text-lg shadow-lg transition duration-200"
            >
              Join Ceviliyar
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Partner;
